import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { toast } from "@/components/ui/toast"
import { birthdaysApi } from "@/lib/birthdays-api"
import { birthdaysKeys } from "@/lib/query-keys"

const notifyMutationError = (error: Error) => toast.error(error.message)

export const useBirthdayConfigQuery = () =>
  useQuery({
    queryKey: birthdaysKeys.config(),
    queryFn: () => birthdaysApi.getConfig(),
  })

export const useUpdateBirthdayConfigMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: birthdaysApi.updateConfig,
    onSuccess: (data) => {
      void qc.invalidateQueries({ queryKey: birthdaysKeys.config() })
      if (data.warnings && data.warnings.length > 0) {
        for (const warning of data.warnings) {
          toast.warning(warning)
        }
      } else {
        toast.success("Birthday settings saved")
      }
    },
    onError: notifyMutationError,
  })
}
